module.exports = __webpack_public_path__ + "static/media/terraceLogo.9c5f536f.png";